import React, { useState } from "react";
import { Box, Button, Modal } from "@mui/material";
import { Spinner } from "../../components";
import { Button as Btn, Typography } from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "../../assets/admin/edit-icon.svg";
import Permission from "../../model/permission";
import DeleteModal from "../modal/DeleteModal";
import ApiService from "../../service/ApiService";
import { DatabaseEntities } from "../../model/enum/database-entities.enum";
import AlertService from "../../service/AlertService";
import ToastMessages from "../../model/enum/toast-messages.enum";
import useStyles from "./styles";
import Misc from "../../utils/Misc";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "35rem",
  bgcolor: "background.paper",
  border: "none",
  borderRadius: "8px",
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
  maxHeight: "90vh", // Restrict maximum height to 80% of the viewport height
  overflowY: "auto", // Enable vertical scrolling
  "@media (max-width: 640px)": {
    width: "80%",
  },
};

const PermissionModal = ({ permission, resetList }: any) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const edit = permission != null;
  const id = edit ? permission.id : 0;
  const [name, setName] = useState(edit ? permission.name : "");
  const [loading, setLoading] = useState(false);

  const handleName = (e: any) => setName(e.target.value);

  const handleCreate = async (payload: Permission) => {
    return await ApiService.post<Permission>(
      DatabaseEntities.PERMISSIONS,
      payload
    )
      .then((res: Permission) => {
        AlertService.success(ToastMessages.CREATED);
        return res;
      })
      .catch(() => {
        AlertService.error(ToastMessages.CREATE_FAILED);
        return undefined;
      });
  };

  const handleUpdate = async (payload: Permission) => {
    await ApiService.put<Permission>(
      `${DatabaseEntities.PERMISSIONS}/${payload.id}`,
      payload
    )
      .then((res: Permission) => {
        AlertService.success(ToastMessages.UPDATED);
        return res;
      })
      .catch(() => {
        AlertService.error(ToastMessages.UPDATE_FAILED);
      });
  };

  const handleDelete = async (payload: Permission) => {
    await ApiService.delete<any>(
      `${DatabaseEntities.PERMISSIONS}/${payload.id}`
    )
      .then(() => {
        AlertService.success(ToastMessages.DELETED);
        resetList?.();
      })
      .catch(() => {
        AlertService.error(ToastMessages.DELETE_FAILED);
      });
  };

  const invalidInput = () => {
    return Misc.isNullOrEmpty(name);
  };

  const register = async () => {
    if (invalidInput()) return;

    setLoading(true);
    const payload: Permission = {
      id: id,
      name: name,
    };

    if (edit) await handleUpdate(payload);
    else await handleCreate(payload);

    setLoading(false);
    resetList?.();
    handleClose();
  };

  return (
    <div>
      {edit ? (
        <Button onClick={handleOpen}>
          <img src={EditIcon} alt="edit icon" />
        </Button>
      ) : (
        <Btn
          className={classes.headerButton}
          variant="contained"
          onClick={handleOpen}
        >
          + Add Permission
        </Btn>
      )}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ overflowY: "auto" }}
      >
        {loading ? (
          <Spinner />
        ) : (
          <Box sx={style}>
            <div className={classes.headerDiv}>
              {edit ? (
                <Typography className={classes.title}>
                  <DeleteModal item={permission} handleDelete={handleDelete} />
                </Typography>
              ) : (
                <Typography className={classes.title}>
                  Add permission
                </Typography>
              )}
              <Button onClick={handleClose} sx={{ color: "black" }}>
                <CloseIcon />
              </Button>
            </div>
            <hr />
            <div className={classes.form}>
              <input
                className={classes.input}
                type="text"
                value={name}
                onChange={handleName}
                placeholder="Permission name"
              />
            </div>
            <div className={classes.buttonDiv}>
              <Btn
                className={classes.button}
                onClick={register}
                disabled={invalidInput()}
              >
                {edit ? "Save" : "Create"}
              </Btn>
            </div>
          </Box>
        )}
      </Modal>
    </div>
  );
};

export default PermissionModal;
